module.exports = __webpack_public_path__ + "assets/Credit-Card-Paypal.240cba25.svg";